import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import { supabase } from '../utils/supabaseClient.js';
import SEO from './SEO.js';
import ProductBox from './ProductBox.js';
import ProductSkeleton from './ProductSkeleton.js';

const CategoryPage = () => {
  const { categoryName } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);

  const PRODUCTS_PER_PAGE = 12;

  const loadProducts = useCallback(async () => {
    try {
      const from = page * PRODUCTS_PER_PAGE;
      const to = from + PRODUCTS_PER_PAGE - 1;

      const { data, error } = await supabase
        .from('products')
        .select('*')
        .eq('category', categoryName) // Filter by Category
        .range(from, to)
        .order('id', { ascending: true });

      if (error) throw error;

      if (data.length === 0) setHasMore(false);
      
      const mapped = data.map(p => ({
        ...p, name: p.title, imageUrls: p.image_urls || [], keywords: p.keywords || []
      }));

      setProducts(prev => [...prev, ...mapped]);
      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
    }
  }, [categoryName, page]);

  useEffect(() => {
    setProducts([]);
    setPage(0);
    setHasMore(true);
    setLoading(true);
    loadProducts();
  }, [categoryName]);

  useEffect(() => {
    if (page > 0) loadProducts();
  }, [page, loadProducts]);

  return (
    <div className="container mt-5">
      <SEO title={`${categoryName} Products`} />
      <h1 className="mb-4 text-capitalize">{categoryName}</h1>
      
      {products.length === 0 && !loading ? (
        <div className="alert alert-warning">No products found in this category.</div>
      ) : (
        <InfiniteScroll
            dataLength={products.length}
            next={() => setPage(prev => prev + 1)}
            hasMore={hasMore}
            loader={<div className="row">{[...Array(4)].map((_, i) => <ProductSkeleton key={i} />)}</div>}
        >
            <div className="row">
            {products.map((product) => (
                <ProductBox key={product.id} product={product} />
            ))}
            </div>
        </InfiniteScroll>
      )}
    </div>
  );
};

export default CategoryPage;